import {
    SAVE_EQUITY_DETAILS,
    SAVE_EQUITY_DETAILS_SUCCESS,
    SAVE_EQUITY_DETAILS_FAILURE,
    RESET_CREATE_EQUITY,
} from '../actions/actionTypes';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    saveEquity: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    saveEquityLoading: false,
};

const createEquityReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_EQUITY_DETAILS:
            return {
                ...state,
                saveEquityLoading: true,
            };
        case SAVE_EQUITY_DETAILS_SUCCESS:
            return {
                ...state,
                saveEquity: {
                    data: action.data,
                    statusCode: '10011',
                },
                saveEquityLoading: false,
            };
        case SAVE_EQUITY_DETAILS_FAILURE:
            return {
                ...state,
                saveEquity: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                saveEquityLoading: false,
            };
        case RESET_CREATE_EQUITY:
            return initialState;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'createEquityKey',
        storage: storage,
    },
    createEquityReducer
);
